import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { AfPcDomain } from '../model/af.model';
import { map } from 'rxjs/operators';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class PoliticalContributionService {

  constructor(private readonly userService: AuthService, private readonly http: HttpClient) { }

  getPcGBAM(): Observable<AfPcDomain> {
    return this.http.post<AfPcDomain>(environment.api_uri + 'getPcGBAM', { 'verifyId': this.userService.getVerifyId() }).pipe(
      map(response => {

        response.pcGbamList.forEach(item => {
          if (item.contributionDate) {
            if (item.contributionDate) {
              item.contributionDate = new Date(moment.utc(item.contributionDate).format("MM/DD/YYYY"));
            }
          }
        });

        return response;
      }));
  }

  savePcGBAM(AfPcDomain): Observable<AfPcDomain> {
    const requestUrl = environment.api_uri + 'savePcGBAM';

    AfPcDomain.pcGbamList.forEach(item => {
      if (item.contributionDate) {
        if (item.contributionDate) {
          //java.Sql.Date default string pattern
          item.contributionDateStr = moment(item.contributionDate).format('YYYY-MM-DD');
          item.contributionDate = new Date(moment.utc(item.contributionDate).format("MM/DD/YYYY"));
        }
      }
    });

    return this.http.post<AfPcDomain>(requestUrl, AfPcDomain);
  }

  getPcSurvey(): Observable<AfPcDomain> {
    return this.http.post<AfPcDomain>(environment.api_uri + 'getPcSurvey', { 'verifyId': this.userService.getVerifyId() }).pipe(
      map(response => {

        response.pcCandidateList.forEach(item => {
          if (item.contributionDate) {
            if (item.contributionDate) {
              item.contributionDate = new Date(moment.utc(item.contributionDate).format("MM/DD/YYYY"));
            }
          }
        });

        response.pcPacsList.forEach(item => {
          if (item.contributionDate) {
            if (item.contributionDate) {
              item.contributionDate = new Date(moment.utc(item.contributionDate).format("MM/DD/YYYY"));
            }
          }
        });

        response.pcLocalPartiesList.forEach(item => {
          if (item.contributionDate) {
            if (item.contributionDate) {
              item.contributionDate = new Date(moment.utc(item.contributionDate).format("MM/DD/YYYY"));
            }
          }
        });

        return response;
      }));
  }

  getPcMbam(): Observable<AfPcDomain> {
    return this.http.post<AfPcDomain>(environment.api_uri + 'getPcMbam', { 'verifyId': this.userService.getVerifyId() }).pipe(
      map(response => {

        response.pcCandidateList.forEach(item => {
          if (item.contributionDate) {
            if (item.contributionDate) {
              item.contributionDate = new Date(moment.utc(item.contributionDate).format("MM/DD/YYYY"));
            }
          }
        });

        return response;
      }));
  }

  savePcSurvey(AfPcDomain): Observable<AfPcDomain> {
    const requestUrl = environment.api_uri + 'savePcSurvey';

    AfPcDomain.pcCandidateList.forEach(item => {
      if (item.contributionDate) {
        if (item.contributionDate) {
          //java.Sql.Date default string pattern
          item.contributionDateStr = moment(item.contributionDate).format('YYYY-MM-DD');
          item.contributionDate = new Date(moment.utc(item.contributionDate).format("MM/DD/YYYY"));
        }
      }
    });

    AfPcDomain.pcPacsList.forEach(item => {
      if (item.contributionDate) {
        if (item.contributionDate) {
          //java.Sql.Date default string pattern
          item.contributionDateStr = moment(item.contributionDate).format('YYYY-MM-DD');
          item.contributionDate = new Date(moment.utc(item.contributionDate).format("MM/DD/YYYY"));
        }
      }
    });

    AfPcDomain.pcLocalPartiesList.forEach(item => {
      if (item.contributionDate) {
        if (item.contributionDate) {
          //java.Sql.Date default string pattern
          item.contributionDateStr = moment(item.contributionDate).format('YYYY-MM-DD');
          item.contributionDate = new Date(moment.utc(item.contributionDate).format("MM/DD/YYYY"));
        }
      }
    });

    return this.http.post<AfPcDomain>(requestUrl, AfPcDomain);
  }

  savePcMbam(AfPcDomain): Observable<AfPcDomain> {
    const requestUrl = environment.api_uri + 'savePcMbam';

    AfPcDomain.pcCandidateList.forEach(item => {
      if (item.contributionDate) {
        //java.Sql.Date default string pattern 
        item.contributionDateStr = moment(item.contributionDate).format('YYYY-MM-DD');
        item.contributionDate = new Date(moment.utc(item.contributionDate).format("MM/DD/YYYY"));
      }
    });

    return this.http.post<AfPcDomain>(requestUrl, AfPcDomain);
  }
}